import { Controller } from '@hotwired/stimulus'
import { get } from '@rails/request.js'

export default class extends Controller {
  static values = {
    interval: { type: Number, default: 5000 },
    url: String
  }

  connect() {
    this.scheduleRefresh()
  }

  disconnect() {
    this.cancelRefresh()
  }

  scheduleRefresh() {
    this.timeoutId = setTimeout(() => {
      this.refresh()
      this.scheduleRefresh()
    }, this.intervalValue)
  }

  cancelRefresh() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
  }

  async refresh() {
    const url = this.urlValue || window.location.href
    await get(url, { responseKind: 'turbo-stream' })
  }
}
